import { render, staticRenderFns } from "./PixabayImageUpload.vue?vue&type=template&id=1298fd96"
import script from "./PixabayImageUpload.vue?vue&type=script&lang=js"
export * from "./PixabayImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports